export const isNullOrEmpty = (field) => {
    return field == null || field === '' || field === undefined || field === [];
};
  